<template>
  <div class="no-scroll">
    <CRow class="full-height">
      <CCol class="login-section">
        <div class="login-container">
          <CImage :src="footerLogo" alt="Logo" class="sidebar-brand-narrow" :height="65" />
          <br><br>
          <CForm :validated="true">
            <CFormLabel class="form-label">Sign In to your account</CFormLabel>
            <CFormInput style="margin-bottom: 10px;" type="email" v-model="email" placeholder="Email" required :disabled="is_loading"/>
            <CFormInput style="margin-bottom: 10px;" type="password" v-model="password" placeholder="Password" required :disabled="is_loading"
              @keyup.enter="login" />
            <CRow>
              <CCol>
                <CLoadingButton color="success" class="login-btn" @click="login" :loading="is_loading"
                  disabled-on-loading :disabled="!isFormValid">
                  <CIcon icon="cilArrowCircleRight" v-show="!is_loading"/> Login
                </CLoadingButton>
              </CCol>
              <CCol>
                <div class="forgot-password-container">
                  <CLink role="button" @click="goToAccountRecovery" class="forgot-password">Forgot Password</CLink>
                </div>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCol>
      <CCol :style="{
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        position: 'relative'
      }
        ">
        <div class="overlay">
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import image from '@/assets/images/login.jpg'
import footerLogo from '@/assets/logo/footer-logo.png'


export default {
  data() {
    return {
      email: '',
      password: '',
      image,
      footerLogo,
      is_loading: false
    };
  },
  computed: {
    isFormValid() {
      return (
        this.email.trim() !== '' &&
        this.password.trim() !== ''
      );
    }
  },
  mounted() {
    if (this.$route.query.reset === 'success') {
      this.showSuccessAlert();
    }
  },
  methods: {
    async login() {
      this.is_loading = true;
      try {
        const response = await this.$axios.post('/login', {
          email: this.email,
          password: this.password
        });

        const token = response.data.token;
        const ufn = response.data.userName;

        localStorage.setItem('token', token);
        localStorage.setItem('ufn', ufn);

        this.$axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        this.$router.push('/exam-checker');
      } catch (error) {
        if (error.status == 300) {
          return this.$swal({
            position: 'center',
            timer: 4500,
            icon: 'error',
            title: 'Invalid email or password',
            timerProgressBar: true,
          });
        } else if (error.status == 404) {
          return this.$swal({
            position: 'center',
            timer: 4500,
            icon: 'error',
            title: 'User does not exists',
            timerProgressBar: true,
          });
        } else if (error.status == 429) {
          return this.$swal({
            position: 'center',
            timer: 4500,
            icon: 'error',
            title: 'Too many attempts. Try again in 15 minutes.',
            timerProgressBar: true,
          });
        }
      } finally {
        this.is_loading = false;
      }
    },
    goToAccountRecovery() {
      this.$router.push({ name: 'Account recovery' });
    },
    showSuccessAlert() {
      this.$swal({
        toast: true,
        position: 'center',
        icon: "success",
        title: "Password Reset Successful.",
        text: 'Your password has been reset successfully. Please change your password immediately for security.',
        timer: 5000,
        showConfirmButton: false,
        timerProgressBar: true,
      }).then(() => {
        this.$router.replace({ path: '/login' });
      });
    },
  }
};
</script>

<style scoped>
.no-scroll {
  overflow-x: hidden;
  height: 100vh;
  width: 100vw;
}

.full-height {
  height: 100vh;
}

.login-container {
  max-width: 400px;
  width: 100%;
  text-align: center;
}

input {
  display: block;
  width: 100%;
  margin-bottom: 10px;
}

.login-btn {
  color: white;
  float: left;
  padding-left: 30px;
  padding-right: 30px;

}

.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, #004ABE, #0FC15E);
}

.forgot-password-container {
  margin-top: 8px;
}

.forgot-password {
  color: white;
  float: right;
}

.form-label {
  color: white;
  opacity: 80%;
  margin-bottom: 15px;
  margin-top: 15px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.3;
}
</style>